import { Notification } from "vue-notifyjs";

export const displayNotification = (message, type) => {
  Notification.notify({
    message: message,
    horizontalAlign: 'center',
    verticalAlign: 'top',
    type: type,
  });
}